import "core-js/modules/es6.regexp.constructor";
import "core-js/modules/es6.string.ends-with";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.regexp.to-string";
/*
 * vuejs 	过滤器
 * time 	2017年1月18日 18:46:54
 */

import Vue from 'vue';

/**
 * 格式化数字，相当于vue1.0时的currency过滤器
 * @param value        传进来的数字
 * @param symbol        货币称号，默认为人民币
 * @param dat            保留的小数点位数，默认为2位
 * @param return
 */

Vue.filter("isEmpty", function (val) {
  if (val == "" || val == null) {
    return "暂无";
  } else {
    return val;
  }
});
Vue.filter("roleFilter", function (val) {
  if (val == "PROJECT_UNIT") {
    return "项目部";
  } else if (val == "GENERAL_UNIT") {
    return "总局";
  } else if (val == "BRANCH_UNIT") {
    return "分局";
  } else {
    return "未知";
  }
});
// Vue.filter("roleChange", function (val) {
//     val = val.split(",");
//     for (var i = 0; i < val.length; i++) {
//         if (val[i] == "MANAGER") {
//             val[i] = "生产经理";
//         } else if (val[i] == "ADMIN") {
//             val[i] = "管理员";
//         } else if (val[i] == "DRIVER") {
//             val[i] = "司机";
//         } else if (val[i] == "OPERATOR") {
//             val[i] = "操作手";
//         } else if (val[i] == "REPAIRMAN") {
//             val[i] = "修理工";
//         } else if (val[i] == "STATISTICS") {
//             val[i] = "统计";
//         } else {
//             val[i] = "暂无";
//         }
//     }
//     return val.toString();
// });

Vue.filter("sign", function (val) {
  return val ? "正在招标" : "停止招标";
});
Vue.filter("roleEditChange", function (val) {
  if (val == "MANAGER") {
    return "生产经理";
  } else if (val == "ADMIN") {
    return "管理员";
  } else if (val == "DRIVER") {
    return "司机";
  } else if (val == "OPERATOR") {
    return "操作手";
  } else if (val == "REPAIRMAN") {
    return "修理工";
  } else if (val == "STATISTICS") {
    return "统计";
  } else {
    return "暂无";
  }
});
Vue.filter("vehicleIsSelf", function (val) {
  if (val == 0) {
    return "自有设备";
  } else if (val == 1) {
    return "外租设备";
  } else if (val == 2) {
    return "外协设备";
  } else {
    return "未设置设备类型";
  }
});
Vue.filter("vehicleStatus", function (val) {
  if (val == "WORKING") {
    //绿
    return "工作中";
  } else if (val == "NORMAL") {
    //橙色
    return "闲置";
  } else if (val == "READY") {
    //蓝色
    return "已出车";
  } else {
    //灰色
    return "熄火";
  }
});
Vue.filter("status1", function (val) {
  if (val == "CERTIFIED") {
    return "已认证";
  } else if (val == "CERTIFING") {
    return "待认证";
  } else if (val == "UNPASS") {
    return "已驳回";
  } else {
    return "暂无";
  }
});
Vue.filter("isDispose", function (val) {
  if (val) {
    return "已处理";
  } else {
    return "未处理";
  }
});
Vue.filter("sex", function (val) {
  if (val == '1') {
    return "女";
  } else {
    return "男";
  }
});
Vue.filter("timeChange", function (input) {
  if (/^((\d{2}(([02468][048])|([13579][26]))[\-\/\s]?((((0?[13578])|(1[02]))[\-\/\s]?((0?[1-9])|([1-2][0-9])|(3[01])))|(((0?[469])|(11))[\-\/\s]?((0?[1-9])|([1-2][0-9])|(30)))|(0?2[\-\/\s]?((0?[1-9])|([1-2][0-9])))))|(\d{2}(([02468][1235679])|([13579][01345789]))[\-\/\s]?((((0?[13578])|(1[02]))[\-\/\s]?((0?[1-9])|([1-2][0-9])|(3[01])))|(((0?[469])|(11))[\-\/\s]?((0?[1-9])|([1-2][0-9])|(30)))|(0?2[\-\/\s]?((0?[1-9])|(1[0-9])|(2[0-8]))))))(\s((([0-1][0-9])|(2?[0-3]))\:([0-5]?[0-9])((\s)|(\:([0-5]?[0-9])))))?$/.test(input)) {
    if (!new Date(input).getTime()) {
      return "暂无";
    }
    return input;
  }
  if (input) {
    if (input.toString().length > 11) {
      var d;
      if (isNaN(input)) {
        d = new Date(input);
      } else {
        d = new Date(parseInt(input));
        // d = new Date(parseInt(input));
      }
    } else {
      var d = new Date(parseInt(input) * 1000);
    }
    if (!d.getTime()) {
      return "暂无";
    }
    var year = d.getFullYear();
    var month = d.getMonth() + 1;
    var day = d.getDate() < 10 ? '0' + d.getDate() : '' + d.getDate();
    var hour = d.getHours() < 10 ? '0' + d.getHours() : '' + d.getHours();
    var minutes = d.getMinutes() < 10 ? '0' + d.getMinutes() : '' + d.getMinutes();
    var seconds = d.getSeconds() < 10 ? '0' + d.getSeconds() : '' + d.getSeconds();
    return year + '-' + month + '-' + day + ' ' + hour + ':' + minutes + ':' + seconds;
  } else {
    return "暂无";
  }
});
Vue.filter("timeChangeToHour", function (input) {
  if (input) {
    var d = new Date(input);
    var hour = d.getHours() < 10 ? '0' + d.getHours() : '' + d.getHours();
    var minutes = d.getMinutes() < 10 ? '0' + d.getMinutes() : '' + d.getMinutes();
    var seconds = d.getSeconds() < 10 ? '0' + d.getSeconds() : '' + d.getSeconds();
    return hour + ':' + minutes + ':' + seconds;
  } else {
    return "暂无";
  }
});
Vue.filter("timeChangeDayChange", function (input) {
  if (input) {
    var d = new Date(input);
    var year = d.getFullYear();
    var month = d.getMonth() + 1;
    var day = d.getDate() < 10 ? '0' + d.getDate() : '' + d.getDate();
    return year + '-' + month + '-' + day;
  } else {
    return "暂无";
  }
});
Vue.filter("timeChangeToMonth", function (input) {
  if (/^((\d{2}(([02468][048])|([13579][26]))[\-\/\s]?((((0?[13578])|(1[02]))[\-\/\s]?((0?[1-9])|([1-2][0-9])|(3[01])))|(((0?[469])|(11))[\-\/\s]?((0?[1-9])|([1-2][0-9])|(30)))|(0?2[\-\/\s]?((0?[1-9])|([1-2][0-9])))))|(\d{2}(([02468][1235679])|([13579][01345789]))[\-\/\s]?((((0?[13578])|(1[02]))[\-\/\s]?((0?[1-9])|([1-2][0-9])|(3[01])))|(((0?[469])|(11))[\-\/\s]?((0?[1-9])|([1-2][0-9])|(30)))|(0?2[\-\/\s]?((0?[1-9])|(1[0-9])|(2[0-8]))))))(\s((([0-1][0-9])|(2?[0-3]))\:([0-5]?[0-9])((\s)|(\:([0-5]?[0-9])))))?$/.test(input)) {
    return input;
  }
  if (input) {
    if (input.toString().length > 11) {
      var d;
      if (isNaN(input)) {
        d = new Date(input);
      } else {
        d = new Date(parseInt(input));
        // d = new Date(parseInt(input));
      }
    } else {
      var d = new Date(parseInt(input) * 1000);
    }
    var year = d.getFullYear();
    var month = d.getMonth() + 1;
    return year + '-' + month;
  } else {
    return "暂无";
  }
});
Vue.filter("NULL2Empty", function (str) {
  return str ? str : '';
});
Vue.filter("timeChangeDay", function (input) {
  var d;
  if (/^((\d{2}(([02468][048])|([13579][26]))[\-\/\s]?((((0?[13578])|(1[02]))[\-\/\s]?((0?[1-9])|([1-2][0-9])|(3[01])))|(((0?[469])|(11))[\-\/\s]?((0?[1-9])|([1-2][0-9])|(30)))|(0?2[\-\/\s]?((0?[1-9])|([1-2][0-9])))))|(\d{2}(([02468][1235679])|([13579][01345789]))[\-\/\s]?((((0?[13578])|(1[02]))[\-\/\s]?((0?[1-9])|([1-2][0-9])|(3[01])))|(((0?[469])|(11))[\-\/\s]?((0?[1-9])|([1-2][0-9])|(30)))|(0?2[\-\/\s]?((0?[1-9])|(1[0-9])|(2[0-8]))))))(\s((([0-1][0-9])|(2?[0-3]))\:([0-5]?[0-9])((\s)|(\:([0-5]?[0-9])))))?$/.test(input)) {
    if (!new Date(input).getTime()) {
      return "暂无";
    }
    d = new Date(input);
    var year = d.getFullYear();
    var month = d.getMonth() + 1 < 10 ? '0' + (d.getMonth() + 1) : d.getMonth() + 1;
    var day = d.getDate() < 10 ? '0' + d.getDate() : '' + d.getDate();
    return year + '-' + month + '-' + day + ' ';
  }
  if (input) {
    //去掉小数点
    var strInput = input.toString().split(".")[0];
    if (strInput.length > 11) {
      if (isNaN(input)) {
        d = new Date(input);
      } else {
        d = new Date(parseInt(input));
      }
    } else {
      d = new Date(parseInt(input) * 1000);
    }
    if (!d.getTime()) {
      return "暂无";
    }
    var year = d.getFullYear();
    var _month = d.getMonth() + 1 < 10 ? '0' + (d.getMonth() + 1) : d.getMonth() + 1;
    var day = d.getDate() < 10 ? '0' + d.getDate() : '' + d.getDate();
    return year + '-' + _month + '-' + day + ' ';
  } else {
    return "暂无";
  }
});
Vue.filter("getCarMaintainNameByTime", function (input) {
  var d = new Date(input);
  var year = d.getFullYear();
  var month = d.getMonth() + 1;
  return year + '年' + month + '月车辆年审情况月度报表';
});
Vue.filter("getMonthAndDateTime", function (input) {
  var d = new Date(input);
  var hour = d.getHours() < 10 ? '0' + d.getHours() : '' + d.getHours();
  var minutes = d.getMinutes() < 10 ? '0' + d.getMinutes() : '' + d.getMinutes();
  var seconds = d.getSeconds() < 10 ? '0' + d.getSeconds() : '' + d.getSeconds();
  var day = d.getDate() < 10 ? '0' + d.getDate() : '' + d.getDate();
  var month = d.getMonth() + 1 < 10 ? '0' + (d.getMonth() + 1) : d.getMonth() + 1;
  return month + "-" + day + " " + hour + ':' + minutes + ':' + seconds;
});
Vue.filter("timeChangeDayReceipt", function (input) {
  if (!input) {
    return "暂无";
  }
  if (String(input).length > 10) {
    var d = new Date(input);
  } else {
    var d = new Date(input * 1000);
  }
  var year = d.getFullYear();
  var month = d.getMonth() + 1;
  var day = d.getDate() < 10 ? '0' + d.getDate() : '' + d.getDate();
  return year + '年' + month + '月' + day + '日';
});

//合同号随机
Vue.filter("timeChangeHT", function (input) {
  if (String(input).length > 10) {
    var d = new Date(input);
  } else {
    var d = new Date(input * 1000);
  }
  var year = d.getFullYear().toString();
  var month = d.getMonth() + 1;
  var day = d.getDate() < 10 ? '0' + d.getDate() : '' + d.getDate();
  var hour = d.getHours() < 10 ? '0' + d.getHours() : '' + d.getHours();
  var minutes = d.getMinutes() < 10 ? '0' + d.getMinutes() : '' + d.getMinutes();
  var seconds = d.getSeconds() < 10 ? '0' + d.getSeconds() : '' + d.getSeconds();
  var milliSecondes = d.getMilliseconds() < 10 ? '00' + d.getMilliseconds() : d.getMilliseconds() < 100 ? '0' + d.getMilliseconds() : d.getMilliseconds();
  return year + month.toString() + day + hour + minutes + seconds + milliSecondes;
});
Vue.filter("isOut", function (val) {
  if (val) {
    if (val == "1") {
      return "已出车";
    } else {
      return "未出车";
    }
  } else {
    return "无";
  }
});
Vue.filter("isLet", function (val) {
  if (val == "0") {
    return "未外租";
  } else {
    return "已出租";
  }
});
Vue.filter("changeReason", function (val) {
  return JSON.parse(val);
});
Vue.filter("isSelect", function (val) {
  if (val == 0) {
    return '';
  } else if (val == 1) {
    return '（首选）';
  } else if (val == 2) {
    return '（备选）';
  }
});
Vue.filter("natureChange", function (val) {
  if (val == 0) {
    return "国有经济";
  } else if (val == 1) {
    return "集体经济";
  } else if (val == 2) {
    return "个体工商户";
  } else if (val == 3) {
    return "国有独资";
  } else if (val == 4) {
    return "股份公司";
  } else if (val == 5) {
    return "有限责任公司";
  } else if (val == 6) {
    return "合伙企业";
  } else if (val == 7) {
    return "个人独资";
  } else if (val == 8) {
    return "事业法人";
  } else if (val == 9) {
    return "中外合资经营";
  } else if (val == 10) {
    return "外商独资经营";
  } else {
    return "其他";
  }
});
Vue.filter("isVATinvoice", function (val) {
  return val ? "能" : "不能";
});
Vue.filter("settleStatus", function (val) {
  return val == 1 ? "已结算" : "未结算";
});
Vue.filter("changeCurrent", function (val) {
  return val ? "美元" : "人民币";
});
Vue.filter("changeAuditStatus", function (auditStatus) {
  switch (auditStatus) {
    case 2:
      return '公司租赁业务主管';
    case 3:
      return '公司设备物资负责人';
    case 4:
      return '通过';
    case 1:
      return '通过';
    case 0:
      return '驳回';
    default:
      return '未知状态';
  }
});
Vue.filter("history", function (auditStatus, auditResult) {
  auditResult = auditResult == 0 ? false : true;
  if (auditStatus == "BUILD_BID_AUDIT") {
    if (auditResult) {
      return "业务员审核";
    } else {
      return "驳回立项";
    }
  } else if (auditStatus == "SALESMAN_AUDIT") {
    console.log(auditResult);
    if (auditResult) {
      return "分局设备物资部负责人审核";
    } else {
      return "分局设备物资部负责人审核驳回";
    }
  } else if (auditStatus == "WRITE_BID_AUDIT") {
    if (auditResult) {
      return "等待编写邀请书";
    }
  } else if (auditStatus == "PENDING_BID_AUDIT") {
    if (auditResult) {
      return "业务员再次审核";
    } else {
      return "邀请书被驳回";
    }
  } else if (auditStatus == "SALESMAN_AGAIN_AUDIT") {
    if (auditResult) {
      return "待纪委办公室审核";
    } else {
      return "纪委办公室审核驳回";
    }
  } else if (auditStatus == "PENDING_SALESMAN_SEND_BID") {
    if (auditResult) {
      return "待业务员发送邀请书";
    }
  }
});
Vue.filter("bidStatus", function (val) {
  if (val == "BUILD_BID_AUDIT") {
    return "业务员审核";
  } else if (val == "SALESMAN_AUDIT") {
    return "分局设备物资部负责人审核";
  } else if (val == "WRITE_BID_AUDIT") {
    return "等待编写邀请书";
  } else if (val == "BUILD_AUDIT_UN_PASS") {
    return "驳回立项审核";
  } else if (val == "PENDING_BID_AUDIT") {
    return "业务员再次审核";
  } else if (val == "PENDING_SUPERVISION") {
    return "邀请书审核通过，待纪委办公室审核";
  } else if (val == "BID_AUDIT_UN_PASS") {
    return "邀请书审核驳回";
  } else if (val == "SALESMAN_AGAIN_AUDIT") {
    return "待纪委办公室审核";
  } else if (val == "PENDING_SALESMAN_SEND_BID") {
    return "业务员发送邀请书";
  } else if (val == "SUPERVISION_UN_PASS") {
    return "纪委办公室审核失败";
  } else if (val == "BIDDING") {
    return "询比价进行中";
  } else if (val == "ALREADY_OFFER") {
    return "邀请函已报价";
  } else if (val == "STOP_BIDDING") {
    return "停止询比价";
  } else if (val == "UN_SEND_BID") {
    return "未发生";
  } else if (val == "DISCARD_BID") {
    return "邀请函已失效";
  } else if (val == "END_BID") {
    return "询比价已截止邀请";
  } else if (val == "SAVE_BUILD_BID") {
    return "立项保存";
  } else if (val == "PENDING_WIN_BID_AUDIT") {
    return "评标小组审核";
  } else if (val == "PENDING_WIN_BID_VEHICLEDATA") {
    return "设备物资部负责人审核";
  } else if (val == "PENDING_WIN_BID_SUPERVISION") {
    return "纪委办公室领导审核";
  } else if (val == "PENDING_BRANCH_AUDIT_ADMIN") {
    return "分局租赁业务分管领导";
  } else if (val == "PENDING_SALESMAN_AUDIT") {
    return "分局租赁业务主管审核";
  } else if (val == "WINNING_BID") {
    return "询比价已完成";
  } else if (val == "BID_CANCEL") {
    return "已作废";
  } else {
    return "暂无";
  }
});
Vue.filter("auditResult", function (val) {
  return val == -1 ? "未审核" : val == 1 ? "审核通过" : "审核未通过";
});
Vue.filter("auditStatusNew", function (val, remarks) {
  switch (val) {
    case '-1':
      return "等待审核";
    case '1':
      {
        var reg = /\|/g;
        if (remarks) {
          if (reg.test(remarks)) {
            return remarks.split('|')[0];
          } else {
            return '同意';
          }
        } else {
          return '同意';
        }
      }
    case '0':
      return "驳回";
    default:
      return '等待审核';
  }
});
Vue.filter("auditRemarks", function (remarks) {
  if (remarks) {
    if (/\|/.test(remarks)) {
      return remarks.split("|")[1];
    } else {
      return remarks;
    }
  } else {
    return remarks;
  }
});
Vue.filter("auditStatusNewFirst", function (val) {
  return val == -1 ? "等待审核" : val == 1 ? "已核" : "驳回";
});
Vue.filter("branchUnitName", function (val) {
  return val ? val : '总局';
});
Vue.filter("auditRemarksNew", function (remarks) {
  if (remarks) {
    if (/\|/.test(remarks)) {
      remarks = remarks.split("|")[1];
    }
    if (remarks) {
      return remarks;
    } else {
      return '暂无';
    }
  } else {
    return '暂无';
  }
});
function bidAuditNew(val, auditStatus) {
  switch (val) {
    case "BID_BUILD":
      {
        return "编制立项";
      }
    case "BID_PENDING_AUDIT_PROJECT_VEHICLE_DATA_ADMIN":
      {
        return "设备物资负责人";
      }
    case "BID_PENDING_AUDIT_BRANCH_RENT_SALESMAN":
      {
        return "分局租赁业务主管";
      }
    case "BID_UN_PASS_BY_BRANCH_RENT_SALESMAN":
      {
        return "分局业务主管驳回";
      }
    case "BID_PENDING_AUDIT_BRANCH_VEHICLE_DATA_ADMIN":
      {
        return "分局设备物资部负责人";
      }
    case "BID_REVIEW_PENDING_AUDIT_BRANCH_VEHICLE_DATA_ADMIN":
      {
        return "分局设备物资部负责人";
      }
    case "BID_UN_PASS_BY_BRANCH_VEHICLE_DATA_ADMIN":
      {
        return "分局设备物资部负责人驳回";
      }
    case "BID_PENDING_AUDIT_BRANCH_SUPERVISION_ADMIN":
      {
        return "分局纪委办公室负责人";
      }
    case "BID_UN_PASS_BY_BRANCH_SUPERVISION_ADMIN":
      {
        return "分局检察部负责人驳回";
      }
    case "BID_PENDING_SEND_INVITATION_BRANCH_RENT_SALESMAN":
      {
        return "分局租赁业务主管发送邀请书";
      }
    case "BID_PENDING_CREATE_REVIEW_FILE_BRANCH_RENT_SALESMAN":
      {
        return "分局租赁业务主管编制评审文件";
      }
    case "BID_STATUS_OVER":
      {
        return "立项完成";
      }
    case "BID_REVIEW_TIMEOUT":
      {
        return "已截止";
      }
    case "BID_REVIEW_PENDING_OPEN_INVITATION_BRANCH_RENT_SALESMAN":
      {
        return "主管打开报价文件";
      }
    case "BID_REVIEW_PENDING_SUBMIT_BID_REVIEWS_BRANCH_RENT_SALESMAN":
      {
        return "分局租赁业务主管";
      }
    case "BID_REVIEW_PENDING_AUDIT_BID_REVIEWS":
      {
        return "评审小组";
      }
    case "BID_REVIEW_PENDING_AUDIT_BRANCH_SUPERVISION_ADMIN":
      {
        return "分局纪委办公室负责人";
      }
    case "BID_REVIEW_PENDING_AUDIT_BRANCH_AUDIT_ADMIN":
      {
        return "分局租赁业务分管领导";
      }
    case "BID_REVIEW_UN_PASS_BRANCH_AUDIT_ADMIN":
      {
        return "分局租赁业务分管领导作废";
      }
    case "BID_REVIEW_SEND_RESULT_BRANCH_AUDIT_ADMIN":
      {
        return "分局租赁业务主管发送询比价结果通知";
      }
    case "BID_REVIEW_PENDING_SEND_NOTICE_BRANCH_RENT_SALESMAN":
      {
        if (auditStatus == 0) {
          return "已作废";
        } else {
          return "发送通知";
        }
      }
    case "BID_CANCEL":
      {
        return "已作废";
      }
    case "BID_REVIEW_INVALID":
      {
        return "流标";
      }
    case "BID_REVIEW_SUCCESS":
      {
        return "评审成功";
      }
    default:
      {
        return "未知状态";
      }
  }
}
Vue.prototype.$bidAuditNew = bidAuditNew;
Vue.filter("bidAuditNew", bidAuditNew);
Vue.filter("selectEntp", function (val) {
  if (val == 1) {
    return "中标企业";
  }
});
Vue.filter("bidStatusChip", function (val) {
  if (val == 1) {
    return "招标进行中...";
  } else if (val == 2) {
    return "该标书已停止招标";
  } else if (val == -1) {
    return "该标书为保存的标书";
  } else {
    return "作废的标书";
  }
});
Vue.filter("roleChange", function (val) {
  if (val == 'select') {
    return '可查看';
  } else if (val == 'update') {
    return '可更新';
  } else if (val == 'delete') {
    return '可删除';
  } else if (val == 'add') {
    return '可编制';
  }
});
Vue.filter("sort", function (val) {
  if (val == '0') {
    return '';
  } else if (val == '2') {
    return '(首选)';
  } else if (val == '1') {
    return '(备选)';
  }
});
Vue.filter("isRoleName", function (val) {
  if (val == null || val == "") {
    return '未分配角色';
  } else {
    return val;
  }
});
Vue.filter("todoListAndMessage", function (val) {
  if (val) {
    return "[待办事项]";
  } else {
    return "[消息通知]";
  }
});
//-1待接单，0施工中，1待结算，2已完成待审核，3为审核成功，4为审核失败
Vue.filter("orderStatusChange", function (val) {
  if (val == "PENDING_ACCEPT_EMP_WORK_TASK") {
    return "待接单";
  } else if (val == "WORKING_EMP_WORK_TASK") {
    return "施工中";
  } else if (val == "PENDING_DONE_EMP_WORK_ORDER") {
    return "待完成";
  } else if (val == "PENDING_SETTLEMENT_EMP_WORK_TASK") {
    return "待结算";
  } else if (val == "DONE_EMP_WORK_TASK") {
    return "已完成";
  } else if (val == "PENDING_AUDIT_EMP_WORK_ORDER") {
    return "待审核";
  } else if (val == "UN_PASS_AUDIT_EMP_WORK_ORDER") {
    return "被驳回";
  } else if (val == "PASS_AUDIT_EMP_WORK_ORDER") {
    return "已通过";
  } else if (val == "COMPLETED_AUDIT_UN_PASS") {
    return "机械使用签认单未通过";
  } else if (val == "DENY_EMP_WORK_TASK") {
    return "已拒绝";
  } else {
    return "未知";
  }
});
Vue.filter("todoListAndMessage", function (val) {
  if (val) {
    return "[待办事项]";
  } else {
    return "[消息通知]";
  }
});
Vue.filter("deptTag", function (val) {
  if (val == 'BRANCH_UNIT') {
    return "分局单位";
  } else if (val == 'PROJECT_UNIT') {
    return "项目部单位";
  } else if (val == 'VEHICLE_DATA') {
    return "设备物资管理";
  } else if (val == 'SUPERVISION') {
    return "纪委办公室";
  } else if (val == 'GENERAL_ORGAN') {
    return "总局机关";
  } else if (val == 'BRANCH_ORGAN') {
    return "分局机关";
  } else if (val == "SECURITY") {
    return "安全管理";
  } else if (val == "GENERAL_UNIT") {
    return "总局单位";
  } else if (val == "GENERAL") {
    return "其它管理";
  } else {
    return "未知";
  }
});
Vue.filter("deptAddBtn", function (val) {
  if (val == 'BRANCH_UNIT') {
    return "项目部单位";
  } else if (val == 'PROJECT_UNIT') {
    return "项目部部门";
  } else if (val == 'VEHICLE_DATA') {
    return "设备物资管理";
  } else if (val == 'SUPERVISION') {
    return "监察";
  } else if (val == 'GENERAL_ORGAN') {
    return "总局机关";
  } else if (val == 'BRANCH_ORGAN') {
    return "分局机关";
  } else if (val == "GENERAL_UNIT") {
    return "总局";
  } else if (val == "SECURITY") {
    return "安全管理";
  } else if (val == "GENERAL") {
    return "其它部门";
  } else {
    return "未知";
  }
});
Vue.filter("isPullBlack", function (val) {
  if (val) {
    return "是";
  } else {
    return "否";
  }
});
Vue.filter("bidType", function (val) {
  if (val == 1) {
    return "邀请询比价";
  } else if (val == 2) {
    return "公开询比价";
  } else if (val == 0) {
    return "暂无";
  }
});
Vue.filter("changeVehicleType", function (val) {
  return val;
  // if (val == 'pumpVehicle') {
  //   return '泵车';
  // } else if (val=='dangerousTransVehicle'){
  //   return '危险品运输车'
  // }else if (val=='mixerVehicle'){
  //   return '搅拌车'
  // } else if (val=='diggerVehicle'){
  //   return '挖掘机'
  // }  else if (val=='carPumpVehicle'){
  //   return '车载泵'
  // } else if (val=='paversVehicle'){
  //   return '摊铺机'
  // } else if (val=='graderVehicle'){
  //   return '平地机'
  // } else if (val=='millingMachineVehicle'){
  //   return '铣刨机'
  // } else if (val=='rotaryDrillingRigVehicle'){
  //   return '旋挖钻机'
  // } else {
  //   return '暂无';
  // }
});
Vue.filter("changeAuditEmp", function (val) {
  if (val == 'BRANCH_CAR_ADMIN') {
    return '车辆负责人';
  } else if (val == 'BRANCH_SALESMAN') {
    return '分局租赁业务主管';
  } else if (val == 'BRANCH_AUDIT_ADMIN') {
    return '分局租赁业务分管领导';
  } else if (val == 'GENERAL_AUDIT_ADMIN') {
    return '公司租赁业务主管';
  } else if (val == 'GENERAL_PART_MANAGE_ADMIN') {
    return '公司设备物资负责人';
  } else if (val == 'VEHICLE_DATA_ADMIN') {
    return '设备物资负责人';
  } else if (val == 'SUPERVISION_ADMIN') {
    return '纪委办公室负责人';
  } else if (val == 'OFFICE_CAR_MANAGER') {
    return '办公室车辆年审管理人员';
  } else {
    return '未知';
  }
});
Vue.filter("getTaskStatus", function (val) {
  if (val == 'TASK_WAIT_ACCEPT') {
    return '待接单';
  } else if (val == 'TASK_GONING') {
    return '已接受';
  } else if (val == 'TASK_CANCELED') {
    return '已取消';
  } else if (val == 'TASK_ON_AUDITTING') {
    return '已接受';
  } else if (val == 'TASK_DONE') {
    return '已接受';
  } else if (val == 'CONTRACT_TASK_REFUSED') {
    return '已拒绝';
  } else if (val == 'TASK_STOPPED') {
    return '已结束';
  } else {
    return '未知状态';
  }
});
Vue.filter("emptyMsg", function (val) {
  return val ? val : '暂无';
});
Vue.filter("isProtect", function (val) {
  if (val) {
    return '是';
  } else {
    return '否';
  }
});
Vue.filter("address", function (val) {
  if (val) {
    var reg = /\//g;
    var undefindReg = /undefined/g;
    return val.replace(reg, '').replace(undefindReg, '');
  } else {
    return '暂无';
  }
});
Vue.filter("protectType", function (val) {
  if (val === 'WORKLOAD' || val === "按量") {
    return '按量';
  } else if (val === 'WORKTIME' || val === "按时长") {
    return '按时长';
  } else {
    return '暂无';
  }
});
Vue.filter("changeUnitName", function (projectUnitName, brancheUnitName) {
  if (projectUnitName != null && projectUnitName != '') {
    return projectUnitName;
  } else if (brancheUnitName != null && brancheUnitName != '') {
    return brancheUnitName;
  } else {
    return "总局";
  }
});
Vue.filter("contractStatus", function (val) {
  if (val == 'CONTRACT_EARLY_CLOSURE') {
    return '已提前结束';
  } else if (val == 'CONTRACT_EXPIRED') {
    return '已过期';
  } else if (val == 'CONTRACT_NORMAL') {
    return '正常';
  } else if (val == 'CONTRACT_UN_NORMAL') {
    return '待上传附件';
  } else if (val == 'CONTRACT_UN_DONE') {
    return '待完善';
  } else if (val == 'CONTRACT_EARLY_CLOSURE') {
    return '提前结束';
  } else if (val == 'CONTRACT_END') {
    return '到期结束';
  } else if (val == 'CONTRACT_UN_NORMAL') {
    '待上传附件';
  } else if (val == 'CONTRACT_ONGOING') {
    return '正常进行';
  } else if (val == 'CONTRACT_DELAYED') {
    return '已延期';
  } else {
    return '未知';
  }
});
Vue.filter("projectUnitName", function (branchUnitName, projectUnitName) {
  if (branchUnitName && projectUnitName) {
    return branchUnitName + projectUnitName;
  } else if (!branchUnitName && !projectUnitName) {
    return "总局";
  } else if (!projectUnitName || branchUnitName) {
    return branchUnitName + "本部";
  }
});
Vue.filter("nature", function (val) {
  switch (val) {
    case 0:
      return '国有经济';
    case 1:
      return '集体经济';
    case 2:
      return '个体工商户';
    case 3:
      return '国有独资';
    case 4:
      return '股份公司';
    case 5:
      return '有限责任公司';
    case 6:
      return '合伙企业';
    case 7:
      return '乡镇企业';
    case 8:
      return '个人独资';
    case 9:
      return '事业法人';
    case 10:
      return '中外合资经营';
    case 11:
      return '中外合作经营';
    case 12:
      return '外商独资经营';
    default:
      return '暂无';
  }
});
Vue.filter("natureStr", function (val) {
  switch (val) {
    case '0':
      return '国有经济';
    case '1':
      return '集体经济';
    case '2':
      return '个体工商户';
    case '3':
      return '国有独资';
    case '4':
      return '股份公司';
    case '5':
      return '有限责任公司';
    case '6':
      return '合伙企业';
    case '7':
      return '乡镇企业';
    case '8':
      return '个人独资';
    case '9':
      return '事业法人';
    case '10':
      return '中外合资经营';
    case '11':
      return '中外合作经营';
    case '12':
      return '外商独资经营';
    default:
      return '暂无';
  }
});
Vue.filter("queren", function (val) {
  switch (val) {
    case 0:
      return '待签认';
    case 1:
      return '通过';
    case 2:
      return '驳回';
    case -1:
      return '草稿';
    default:
      return '暂无';
  }
});
Vue.filter("blackStatus", function (val) {
  if (val) {
    return '同意';
  } else {
    return '驳回';
  }
});
Vue.filter('toChies', function (val) {
  //形参
  if (!val) return '';
  val = val.toString().replace(/\$|\,/g, '');
  if (isNaN(val)) {
    val = "0";
  }
  var sign = val == (val = Math.abs(val));
  val = Math.floor(val * 100 + 0.50000000001);
  var cents = val % 100;
  val = Math.floor(val / 100).toString();
  if (cents < 10) {
    cents = "0" + cents;
  }
  for (var i = 0; i < Math.floor((val.length - (1 + i)) / 3); i++) {
    val = val.substring(0, val.length - (4 * i + 3)) + ',' + val.substring(val.length - (4 * i + 3));
  }
  return (sign ? '' : '-') + val + '.' + cents;
});
Vue.filter("tableType", function (val) {
  switch (val) {
    case 0:
      return '固定设备签认表';
    case 1:
      return '移动设备签认表';
    default:
      return '暂无';
  }
});

// 格式化价格，保留两位小数
Vue.filter('formatPrice', function (num) {
  num = parseFloat(num);
  if (isNaN(num)) {
    return '0.00';
  }
  return num.toFixed(2);
});
Vue.filter('numberAddUnit', function (num, unit) {
  num = parseFloat(num);
  if (isNaN(num)) {
    return '0' + unit;
  }
  return num + unit;
});
Vue.filter('formatDate', function (dateStr) {
  if (!dateStr) return;
  if (dateStr.endsWith('日')) {
    return dateStr;
  }
  return dateStr.replace('-', '年').replace('-', '月') + '日';
});
Vue.filter('confirmOrderStatus', function (status) {
  switch (status) {
    case 0:
      return '待签认';
    case 1:
      return '已签认';
    case -1:
      return '已回退';
    default:
      return '暂无';
  }
});

/**
 * yyyy-MM
 * @param dateStr
 * @returns {string}
 */
Vue.filter('YYYYMM', function (dateStr) {
  if (dateStr) {
    var date = new Date(dateStr);
    return dateFormat('yyyy-MM', date);
  } else {
    return '';
  }
});

/**
 * yyyy年M月
 * @param dateStr
 * @returns {string}
 */
Vue.filter('YYYYMM_ZH', function (dateStr) {
  if (dateStr) {
    var date = new Date(dateStr);
    return dateFormat('yyyy年M月', date);
  } else {
    return '';
  }
});

/**
 * yyyy-MM-dd HH:mm
 * @param dateStr
 * @returns {string}
 */
Vue.filter('YYYYMMhhmm', function (dateStr) {
  if (dateStr) {
    var date = new Date(dateStr);
    return dateFormat('yyyy-MM-dd hh:mm', date);
  } else {
    return '';
  }
});

// 时间格式化
function dateFormat(fmt, date) {
  var o = {
    "M+": date.getMonth() + 1,
    //月份 
    "d+": date.getDate(),
    //日 
    "h+": date.getHours(),
    //小时 
    "m+": date.getMinutes(),
    //分 
    "s+": date.getSeconds(),
    //秒 
    "q+": Math.floor((date.getMonth() + 3) / 3),
    //季度 
    "S": date.getMilliseconds() //毫秒 
  };
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
  for (var k in o) {
    if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
  }
  return fmt;
}